import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FaHome, FaInfoCircle, FaBoxOpen, FaEnvelope } from 'react-icons/fa';
import './css_components/Header.css';
import HamburgerMenu from '../MyComponents/pages/HamburgerMenu';

const Header = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      setVisible(currentY < lastScrollY || currentY < 100);
      setLastScrollY(currentY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const getLinkClass = (path) => {
    return location.pathname === path
      ? 'text-primary-custom text-decoration-none d-flex align-items-center gap-1'
      : 'text-white text-decoration-none d-flex align-items-center gap-1';
  };
  

  return (
    <header
      className="d-flex align-items-center justify-content-between px-4 py-2 header-container"
      style={{
        position: 'fixed',
        top: visible ? '20px' : '-100px',
        left: '50%',
        transform: 'translateX(-50%)',
        transition: 'top 0.4s ease-in-out',
        width: '75%',
        background: 'rgba(44, 58, 80, 0.5)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderRadius: '16px',
        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        fontFamily: 'Poppins, sans-serif',
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <img src="/logo.png" alt="Logo" style={{ width: '40px', height: '40px' }} />
        <span className="fs-5 fw-bold" style={{ color: '#dcd6d2' }}>InkMudra</span>
      </div>


      <nav className="d-flex align-items-center gap-5 nav-menu">
        <a href="/" className={getLinkClass('/')}>
          <FaHome /> <span>Home</span>
        </a>
        <a href="/about" className={getLinkClass('/about')}>
          <FaInfoCircle /> <span>About Us</span>
        </a>
        <a href="/products" className={getLinkClass('/products')}>
          <FaBoxOpen /> <span>Products</span>
        </a>
        {/* <a href="#calculator" className="text-white text-decoration-none d-flex align-items-center gap-1">
          <FaCalculator /> <span>Price Calculator</span>
        </a> */}
        <a href="/contact" className={getLinkClass('/contact')}>
          <FaEnvelope /> <span>Contact Us</span>
        </a>
      </nav>

      <div className="burger">
          <HamburgerMenu/>
      </div>
      
    

      
       

    </header>
  );
};

export default Header;
